import React, { Fragment, lazy, Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CallAPI } from "../../utils/apiActions";
import {
  AFFILIATE_SUBSCRIPTION,
  BOT_DELETE,
  BOT_LIST_WITH_STATUS,
  DASHBOARD_CHAT_DETAILS,
  USER_MESSAGE_USAGE,
} from "../../utils/APIEndPoints";
import { LABEL, paginationObj } from "../../utils/constant";
import { showToast } from "../../helper/toastHelper";
import Swal from "sweetalert2";
// import { Area, AreaChart, CartesianGrid, Label, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import useAuth from "../../hooks/useAuth";
import useDashboard from "../../hooks/useDashboard";
// import CardStattics from "./CardStattics";
// import GraphStatistics from "./GraphStatistics";
// import BotListStatistics from "./BotListStatistics";
import moment from "moment";
// import AffiliateUsersList from "../Affiliate/AffiliateUsersList";
import SplashScreen from "../SplashScreen";
import { useCallAPI } from "../../hooks/useCallAPI";

const CardStattics = lazy(() => import("./CardStattics"));
const GraphStatistics = lazy(() => import("./GraphStatistics"));
const BotListStatistics = lazy(() => import("./BotListStatistics"));
const AffiliateUsersList = lazy(
  () => import("../Affiliate/AffiliateUsersList"),
);

const getKeyTypeWise = {
  totalchatbots: {
    1: "adminTotalChatBot",
    2: "totalChatBots",
    3: "adminTotalChatBot",
    4: "totalChatBots",
  },
  totalActiveChatBots: {
    1: "adminTotalActiveChatBotsCurrent",
    2: "totalActiveChatBots",
    3: "adminTotalActiveChatBotsCurrent",
    4: "totalActiveChatBots",
  },
};

const hasValue = (value) =>
  value !== "" && value !== null && value !== undefined;

const formatRemainingMessageCount = (messageStatistic) =>
  `${messageStatistic.left} / ${messageStatistic.total}`;

export default function DashboardMain() {
  const { user, accessType } = useAuth();
  const {
    getDashboardAndAnalyticsData,
    dashbordAndAnalyticsData,
    isLoading,
    saveFcmToken,
  } = useDashboard();
  const [cardDetails, setCardDetails] = useState([]);
  const [selectedBot, setSelectedBot] = useState(null);
  const [messageGraph, setMessageGraph] = useState(null);
  const [messageStatistic, setMessageStatistic] = useState({
    left: "",
    total: "",
  });

  const [dateFilter, setDateFilter] = useState({
    fromDate: new Date(moment().subtract(30, "days")),
    toDate: new Date(moment()),
  });

  /* ---------------- Affiliate APIs ---------------- */
  const {
    loading: totalEarningResLoading,
    data: totalEarningRes,
    revalidate: fetchTotalEarning,
  } = useCallAPI({
    end_point: "SUBSCRIPTION",
    method: "POST",
    apiUrl: AFFILIATE_SUBSCRIPTION.EARNING_DETAILS,
    enabled: false,
  });

  const {
    loading: acceptedEarningResLoading,
    data: acceptedEarningRes,
    revalidate: fetchAcceptedEarning,
  } = useCallAPI({
    end_point: "SUBSCRIPTION",
    method: "POST",
    apiUrl: AFFILIATE_SUBSCRIPTION.EARNING_DETAILS,
    enabled: false,
  });

  const {
    loading: earningByDateResLoading,
    data: earningByDateRes,
    revalidate: fetchEarningByDate,
  } = useCallAPI({
    end_point: "SUBSCRIPTION",
    method: "POST",
    apiUrl: AFFILIATE_SUBSCRIPTION.EARNING_BY_DATE_RANGE,
    enabled: false,
  });

  /* ---------------- Dashboard Chat ---------------- */
  const {
    loading: dashboardChatResLoading,
    data: dashboardChatRes,
    revalidate: fetchDashboardChat,
  } = useCallAPI({
    end_point: "CHAT",
    method: "GET",
    apiUrl: "",
    enabled: false,
  });

  const FCMTOKEN = localStorage.getItem("FcmToken");

  const getAffiliateDashboardData = () => {
    let body = { userId: user.id };

    if (dateFilter.fromDate && dateFilter.toDate) {
      body.fromDate = moment(dateFilter.fromDate).format("YYYY-MM-DD");
      body.toDate = moment(dateFilter.toDate).format("YYYY-MM-DD");
    }

    fetchTotalEarning(body);
    fetchAcceptedEarning({ ...body, status: 1 });
    fetchEarningByDate({ ...body, dateFilter });
  };

  const getDashboardChatDetails = () => {
    let URL = `${DASHBOARD_CHAT_DETAILS}/${user.userUuid}/`;

    if (selectedBot && selectedBot !== 0) {
      URL = `${URL}?botID=${selectedBot}`;
    }

    fetchDashboardChat(undefined, URL);
  };

  useEffect(() => {
    if (!totalEarningRes || !acceptedEarningRes || !earningByDateRes) return;

    setMessageGraph(earningByDateRes?.res?.data?.data);

    const total = +totalEarningRes?.res?.data?.data || 0;
    const accepted = +acceptedEarningRes?.res?.data?.data || 0;

    const loCardDetails = [
      { label: "Total Invited Link", count: user?.totalInvitedLinks || 0 },
      { label: "Total Confirmed User", count: user?.totalConfirmedUsers || 0 },
      { label: "Complete Earning", count: accepted.toFixed(2) },
      { label: "Pending Earning", count: (total - accepted).toFixed(2) },
      { label: "Total Earning", count: total.toFixed(2) },
    ];

    setCardDetails(loCardDetails);
  }, [totalEarningRes, acceptedEarningRes, earningByDateRes]);

  useEffect(() => {
    if (!dashboardChatRes?.res?.data) return;

    const chatData = dashboardChatRes.res.data;

    setMessageGraph(chatData.total_incoming_chat);

    let loCardDetails = [
      {
        label: "Total Bots",
        count:
          dashbordAndAnalyticsData[getKeyTypeWise.totalchatbots[accessType]],
      },
      {
        label: "Total Active Bots",
        count:
          dashbordAndAnalyticsData[
            getKeyTypeWise.totalActiveChatBots[accessType]
          ],
      },
      {
        label: "Total Incoming Chats",
        count: chatData.chat_summary?.all_incoming_chats,
      },
    ];

    loCardDetails.push(
      [1, 3].includes(accessType)
        ? {
            label: "Total Transaction",
            count: dashbordAndAnalyticsData.adminTotalTransactionsCurrent,
          }
        : {
            label: "Total Active Chats",
            count: chatData.chat_summary?.active_chats,
          },
    );

    if (hasValue(messageStatistic.left) && hasValue(messageStatistic.total)) {
      loCardDetails.push({
        label: "Remaining Message Count",
        displayCount: formatRemainingMessageCount(messageStatistic),
      });
    }

    setCardDetails(loCardDetails);
  }, [
    accessType,
    dashbordAndAnalyticsData,
    dashboardChatRes,
    messageStatistic.left,
    messageStatistic.total,
  ]);

  const handleUserMessageCount = async () => {
    try {
      const res = await CallAPI(
        "CHAT",
        "GET",
        `${USER_MESSAGE_USAGE}?userId=${user?.id}`,
      );

      const planLimit = Number(res?.res?.data?.plan_limit) || 0;
      const usedMessages = Number(res?.res?.data?.used_messages) || 0;

      setMessageStatistic({
        left: Math.max(planLimit - usedMessages, 0),
        total: planLimit,
      });
    } catch (err) {
      // ignore
    }
  };

  useEffect(() => {
    if (accessType != 5) {
      getDashboardAndAnalyticsData("", user);
    }
  }, []);

  useEffect(() => {
    if (
      "activeChatbotPercentageChange" in dashbordAndAnalyticsData &&
      accessType != 5
    ) {
      getDashboardChatDetails();
    } else if (accessType == 5) {
      getAffiliateDashboardData();
    }
  }, [dashbordAndAnalyticsData, selectedBot, dateFilter]);

  useEffect(() => {
    if (FCMTOKEN && accessType != 5) {
      saveFcmToken({ firebaseToken: FCMTOKEN });
    }
  }, [FCMTOKEN]);

  useEffect(() => {
    if (user?.id) handleUserMessageCount();
  }, [user?.id]);

  const loading =
    totalEarningResLoading ||
    acceptedEarningResLoading ||
    earningByDateResLoading ||
    dashboardChatResLoading;

  return (
    <React.Fragment>
      {loading ? <SplashScreen /> : null}
      <Suspense fallback={<SplashScreen />}>
        <CardStattics
          cardDetails={cardDetails}
          messageStatistic={messageStatistic}
        />
      </Suspense>
      {user?.userType == 5 ? (
        <Fragment>
          <Suspense fallback={<SplashScreen />}>
            <GraphStatistics
              messageGraph={messageGraph}
              setDateFilter={setDateFilter}
              dateFilter={dateFilter}
            />
          </Suspense>
          <Suspense fallback={<SplashScreen />}>
            <AffiliateUsersList dateFilter={dateFilter} />
          </Suspense>
        </Fragment>
      ) : (
        <>
          {messageGraph ? (
            <Suspense fallback={<SplashScreen />}>
              <GraphStatistics
                setSelectedBot={setSelectedBot}
                messageGraph={messageGraph}
              />
            </Suspense>
          ) : null}
          {messageGraph && (
            <Suspense fallback={<SplashScreen />}>
              <BotListStatistics />
            </Suspense>
          )}
        </>
      )}
    </React.Fragment>
  );
}
